export 	const getCookie = (name: string) => {
  const cookies =  document.cookie.split('; ');
  const map = cookies.reduce((acc, x) => ((acc[x.split('=')?.[0]] = x.split('=')?.[1]), acc), {});
  return map[name];
}